import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useState } from "react";
import { useIntl } from "react-intl";
import { Col, Row } from "reactstrap";
import Toast from "../helpers/Toast";
import ButtonComponent from "./ButtonComponent";
import InputComponent from "./InputComponent";
import { EditSoftwareDTO } from "../models/Equipment/EditSoftwareDTO";
import { EquipmentService } from "../services/EquipmentService";
import { AssistanceDTO } from "../models/Assistance/AssistanceDTO";

export type SoftwareNameAndVersionComponentProps = {
    assistance: AssistanceDTO | undefined;
    equipmentId: number | null;
    currentSoftwareName: string | null;
    currentSoftwareVersion: string | null;
    loading: boolean;
    setAssistance: Function | null | undefined;
    userCanEdit: boolean | undefined;
};

export default function SoftwareNameAndVersionComponent(props: SoftwareNameAndVersionComponentProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [isEditButtonLoading, setIsEditButtonLoading] = useState<boolean>(false);

    const [editSoftware, setEditSoftware] = useState<EditSoftwareDTO>({} as EditSoftwareDTO);

    const intl = useIntl();
    const equipmentService = new EquipmentService();

    const editSoftwareData = async () => {
        setIsEditButtonLoading(true);

        const updateSoftware: EditSoftwareDTO = {
            assistanceId: props.assistance?.id ?? null,
            equipmentId: props.equipmentId,
            softwareName: editSoftware.softwareName ?? "",
            softwareVersion: editSoftware.softwareVersion ?? "",
        };

        const response = await equipmentService.EditSoftware(updateSoftware);
        setIsEditButtonLoading(false);

        if (response.success !== true) {
            Toast.Show("error", response.message);
            return;
        }
        setIsOpen(false);
        Toast.Show("success", response.message);

        if (props.setAssistance) {
            props.setAssistance({
                ...props.assistance,
                softwareName: editSoftware.softwareName,
                softwareVersion: editSoftware.softwareVersion,
            });
        }
    };

    return (
        <>
            <Col md={4} sm={4} xs={4} lg={4} style={{ marginBottom: "8px" }}>
                <ButtonComponent
                    onClick={() => setIsOpen(true)}
                    className="enteraccount"
                    style={{ width: "100%", borderRadius: "10px" }}
                    text={intl.formatMessage({ id: "SoftwareNameAndVersionComponent.Edit" })}
                    disabled={props.loading || props.userCanEdit}
                    loading={props.loading}
                />
            </Col>
            <Dialog 
                open={isOpen}
                fullWidth
                maxWidth="md"
                PaperProps={{ style: { minWidth: 470 } }}
            >
                <DialogTitle>{intl.formatMessage({ id: "SoftwareNameAndVersionComponent.SoftwareEdit.Title" })}</DialogTitle>
                <DialogContent>
                    <Row style={{ margin: "0px", padding: "0px" }}>
                        <InputComponent
                            xl={6}
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={props.currentSoftwareName}
                            label={intl.formatMessage({ id: "ClientEquipmentBidirecional.ActualSoftwareName" })}
                            readOnly={true}
                        />
                        <InputComponent
                            xl={6}
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={props.currentSoftwareVersion}
                            label={intl.formatMessage({ id: "ClientEquipmentBidirecional.ActualSoftwareVersion" })}
                            readOnly={true}
                        />
                    </Row>
                    <Row style={{ margin: "0px", padding: "0px" }}>
                        <InputComponent
                            xl={6}
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={editSoftware?.softwareName}
                            label={intl.formatMessage({ id: "ClientEquipmentBidirecional.NewSoftwareName" })}
                            readOnly={false}
                            onChange={(name: string) => {
                                setEditSoftware({ ...editSoftware, softwareName: name });
                            }}
                        />
                        <InputComponent
                            xl={6}
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={editSoftware.softwareVersion}
                            label={intl.formatMessage({ id: "ClientEquipmentBidirecional.NewSoftwareVersion" })}
                            readOnly={false}
                            onChange={(version: string) => {
                                setEditSoftware({ ...editSoftware, softwareVersion: version });
                            }}
                        />
                    </Row>
                </DialogContent>
                <DialogActions className="loginbuttons">
                    <div style={{ display: "flex", justifyContent: "space-between", margin: "10px", paddingLeft: "5px" }}>
                        <Col md={6} sm={6} xs={6} lg={6}>
                            <ButtonComponent
                                onClick={() => editSoftwareData()}
                                className="enteraccount"
                                style={{ width: "97%", borderRadius: "10px" }}
                                text={intl.formatMessage({ id: "SoftwareNameAndVersionComponent.Create.Success" })}
                                loading={isEditButtonLoading}
                            />
                        </Col>
                        <Col md={6} sm={6} xs={6} lg={6}>
                            <ButtonComponent
                                onClick={() => setIsOpen(false)}
                                className="enteraccount"
                                style={{ width: "97%", borderRadius: "10px" }}
                                text={intl.formatMessage({ id: "SoftwareNameAndVersionComponent.Cancel" })}
                            />
                        </Col>
                    </div>
                </DialogActions>
            </Dialog>
        </>
    );
}
